import api from "./client";

export function getAdminAuditLogs(params = {}) {
  return api.get("/admin/audit-logs", { params });
}

export function getAdminAuditActions() {
  return api.get("/admin/audit-actions");
}

export function verifyAdminAuditChain() {
  return api.get("/admin/audit-verify");
}
